// All Multi-Asset sub-asset fund rules

import { IProduct } from '../../../../models/product'
import { ClassificationRulesService } from '../../../classification-rules/classification-rules.service'
import { FundRuleName } from '../fund-rule-name'
import { IFundRule } from '../ifund-rule'

export class MultiAssetUSMarketRule implements IFundRule {
  ruleName = FundRuleName.MULTI_ASSET_US
  isRuleApplicable(fund: IProduct): boolean {
    //  const result: boolean = UtilityService.wordMatch(fund.regionOfInvestment, "apple");
    return ClassificationRulesService.isUSMultiAsset(fund)
  }
}

export class MultiAssetINTRule implements IFundRule {
  ruleName = FundRuleName.MULTI_ASSET_INTL
  isRuleApplicable(fund: IProduct): boolean {
    return ClassificationRulesService.isIntlMultiAsset(fund)
  }
}

export class MultiAssetTargetDateRule implements IFundRule {
  ruleName = FundRuleName.MULTI_ASSET_TARGET_DATE
  isRuleApplicable(fund: IProduct): boolean {
    return ClassificationRulesService.isTargetDateMultiAsset(fund)
  }
}

export class MultiAssetTargetAllocRule implements IFundRule {
  ruleName = FundRuleName.MULTI_ASSET_TARGET_ALLOCATION
  isRuleApplicable(fund: IProduct): boolean {
    return ClassificationRulesService.isTargetAllocationMultiAsset(fund)
  }
}

export class MultiAssetBalanceRule implements IFundRule {
  ruleName = FundRuleName.MULTI_ASSET_BALANCE
  isRuleApplicable(fund: IProduct): boolean {
    return ClassificationRulesService.isBalancedMultiAsset(fund)
  }
}
